// Scripts
import '~scripts/main';

// Styles
import 'styles/pages/start.scss';

// Packages
import Vue from 'vue';

// Core
import { scrollAnimationProgress } from '~scripts/core/animations';

// Blocks
import Header from '~scripts/blocks/header';
import Navigation from '~scripts/blocks/navigation';
import initRequestForm from '~scripts/blocks/request-form';
import ClientsLogotypes from '~scripts/blocks/vue/ClientsLogotypes.vue';

// Components
import '~scripts/components/modals';

//
// HEADER
//
Header();

//
// NAVIGATION
//
Navigation();

//
// DEMO REQUEST FORM
//
const demoRequestForms = document.querySelectorAll('.js-demo-request-form');

demoRequestForms.forEach((form) => {
  initRequestForm(form);
});

//
// CLIENTS
//
new Vue({
  el: '#VClientsLogotypes',
  name: 'VClientsLogotypes',
  components: {
    ClientsLogotypes,
  },
});

//
// START CARD
//
// Animation
const handleStartItemsAnimation = () => {
  const startItems = document.querySelectorAll('.js-start-item');

  startItems.forEach((startItem) => {
    return scrollAnimationProgress(startItem, {
      getStart(el) {
        const rect = el.getBoundingClientRect();
        return rect.top + window.scrollY - window.innerHeight;
      },
      getEnd(el, start) {
        const height = el.offsetHeight;
        return start + height * 0.5;
      },
    });
  });
};

handleStartItemsAnimation();
